import React, { useEffect } from 'react';
import { Row, Col, Tabs } from 'antd';
import useLastPathname from 'hooks/navigation/useLastPathname';
import Monitoring from 'views/OtherProducts/WebMonitoring/Monitoring';
import { useDispatch } from 'react-redux';
import { getUserSettings } from 'store/entities/otherProducts/thunks';

const WebMonitoring = () => {
  const lastPathname = useLastPathname();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserSettings());
  }, []);

  return (
    <Row className="container">
      <Col span={24}>
        {lastPathname === 'legal-entities' && <Monitoring legalEntities={true} />}
        {lastPathname === 'individual-person' && <Monitoring legalEntities={false} />}
      </Col>
    </Row>
  );
};

export default WebMonitoring;
